var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 5.5C7.6837 5.5 7.62011 5.52634 7.57322 5.57322C7.52634 5.62011 7.5 5.6837 7.5 5.75V17.25C7.5 17.388 7.612 17.5 7.75 17.5H16.25C16.3163 17.5 16.3799 17.4737 16.4268 17.4268C16.4737 17.3799 16.5 17.3163 16.5 17.25V10H13.75C13.2859 10 12.8407 9.81563 12.5126 9.48744C12.1844 9.15925 12 8.71413 12 8.25V5.5H7.75ZM13.5 6.06V8.25C13.5 8.388 13.612 8.5 13.75 8.5H15.94L13.5 6.06ZM6 5.75C6 4.784 6.784 4 7.75 4H12.836C13.3 4 13.745 4.184 14.073 4.513L17.487 7.927C17.816 8.255 18 8.7 18 9.164V17.25C18 17.7141 17.8156 18.1592 17.4874 18.4874C17.1592 18.8156 16.7141 19 16.25 19H7.75C7.28587 19 6.84075 18.8156 6.51256 18.4874C6.18437 18.1592 6 17.7141 6 17.25V5.75Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.dbd879d63abf7063b9c7497930058885.svg";
export { ForwardRef as ReactComponent };